// Static configuration for profile page
export const MENU_ITEMS = {
  GENERAL: [
    { icon: 'CurrencyRupeeRounded', labelKey: 'profile.menuPaymentProfile', key: 'payment' },
    { icon: 'Inventory2', labelKey: 'profile.menuMyOrders', key: 'orders' },
    { icon: 'LockOpenOutlined', labelKey: 'profile.menuChangePassword', key: 'password' },
  ],
  SUPPORT: [
    {
      icon: 'SupportAgentOutlined',
      labelKey: 'profile.menuNeedHelp',
      key: 'help',
    },
    { icon: 'SecurityOutlined', labelKey: 'profile.menuPrivacyPolicy', key: 'privacy' },
  ],
};

export const PROFILE_FIELDS = {
  NAME: { key: 'userName', labelKey: 'profile.fieldName' },
  EMAIL: { key: 'userEmail', labelKey: 'profile.fieldEmail' },
  PHONE: { key: 'userPhoneNumber', labelKey: 'profile.fieldPhone' },
  USER_TYPE: { key: 'userType', labelKey: 'profile.userType' },
  BUSINESS_NAME: { key: 'businessName', labelKey: 'profile.businessName' },
  BUSINESS_GSTIN: { key: 'businessGstinPan', labelKey: 'profile.businessGstinPan' },
  BUSINESS_ADDRESS: { key: 'businessAddress', labelKey: 'profile.businessAddress' },
  KYC_STATUS: { key: 'kycStatus', labelKey: 'profile.kycStatus' },
};

export const USER_TYPES = {
  INDIVIDUAL: 'INDIVIDUAL',
  BUSINESS: 'BUSINESS',
};

export const KYC_STATUS = {
  VERIFIED: 'verified',
  PENDING: 'pending',
  FAILED: 'failed',
};

import { themeColors } from '../../theme/theme';

export const KYC_ICONS = {
  [KYC_STATUS.VERIFIED]: {
    name: 'VerifiedUserOutlined',
    color: themeColors.kycVerifiedColor,
  },
  [KYC_STATUS.PENDING]: {
    name: 'AccessTimeOutlined',
    color: themeColors.kycPendingColor,
  },
  [KYC_STATUS.FAILED]: {
    name: 'WarningAmberOutlined',
    color: themeColors.kycFailedColor,
  },
};

export const NAVIGATION_ROUTES = {
  HISTORY: '/history',
  SUPPORT: '/support',
};

export const PHONE_CONFIG = {
  PREFIX: '+91',
  MAX_LENGTH: 10,
};
